import React from 'react';

const Seperator = ({ visible }) => {
  return visible ? <hr className="separator" /> : null;
};

export default Seperator;
